import {Inject, Injectable, Optional, TemplateRef} from "@angular/core";
import {WINDOW_REF_TOKEN} from "../../../tokens";
import {IDefaultNotificationPayload, INotificationItem} from "../types";
import {IntPortalOutletService} from "../../portal-outlet";

@Injectable()
export class IntNotificationsService {

  template!: TemplateRef<any>;

  portalOutletService!: IntPortalOutletService;

  constructor(
    @Inject(WINDOW_REF_TOKEN) private readonly windowRef: Window,
  ) {}

  setPortalOutletService(portal: IntPortalOutletService) {
    this.portalOutletService = portal;
  }

  setTemplate(template: TemplateRef<any>) {
    this.template = template;
  }

  showDefaultNotification(payload: IDefaultNotificationPayload<unknown>): void | string {
    return this.show<IDefaultNotificationPayload<unknown>>(payload, null, payload.timeout);
  }

  show<T>(payload: T, template: TemplateRef<any> | null, timeoutInMs: number = 3000): void | string {
    if(!this.template) {
      console.warn('Template exist');
      return undefined;
    }
    if(!this.portalOutletService) {
      console.warn('IntPortalOutletService exist');
      return undefined;
    }
    const id = `${Math.random()}`;

    this.portalOutletService.setTemplate(
      template || this.template,
      id,
      {...payload, closeFn: this.close.bind(this, id)} || {}
    );


    setTimeout(() => {
      this.portalOutletService.removeTemplate(id);
    }, timeoutInMs)

    return id;
  }
  close(id: string): void {
    try {
      this.portalOutletService.removeTemplate(id);
    }catch(err) {
      console.log(err);
    }
  }
  getCurrentTimestamp() {
    return +new Date()
  }
}
